import React, { useEffect, useState } from "react";
import { Grid, TextField, Paper, TableContainer, TableBody, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
    AXIOS_TIMEOUT,
    BACKEND_BASE_URL,
    CustSex,
    GET_CUST,
    SET_CUSTOMER,
    SUCCESS,
    formatDateInReact,
    formatDateInSnp,
    isEmpty,
} from "../../constants/Constants";
import axios from "axios";
import DialogBox from "../../global/DialogBox";
import SnpComponent from "../../global/SnpComponent";
import {
    Button, RadioGroup, FormControlLabel,
    FormLabel, Radio
} from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CustomDataGrid from "../../global/CustomDataGrid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import DocumentManager from "../drive/DocumentManager";
import { CUSTVIEW } from "../../constants/Permissions";

export default function Customer() {
    const navigate = useNavigate();
    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        isLoader: false,
        iconReq: false,
        iconContent: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
        handleSnpSubmit: null,
        handleSnpCancel: null,
    };

    const SINGLE_CUST_FORM = {
        id: "",
        custName: "",
        mobNo: "",
        aadharId: "",
        drivingLicense: "",
        panNo: "",
        voterId: "",
        passport: "",
        custDob: "",
        emailId: "",
        address: "",
        custProfession: "",
        custFatherName: "",
        custCompanyName: "",
        custGstDetails: "",
        sex: CustSex.Male,
        tDues: 0.0,
        pAudit: [],
    };
    const todayFormattedDate = new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const { activeShopHash, authUser, isRoleAllowed } = useAuth();
    const [snpLoader, setSnpLoader] = useState(false);
    const [custData, setCustData] = useState([]);
    const [singleCustData, setSingleCustData] = useState(SINGLE_CUST_FORM);
    const [showDialog, setShowDialog] = useState(false);
    const [clearDues, setClearDues] = useState(false);

    useEffect(() => {
        getCustomerData();
    }, []);

    const getCustomerData = async () => {
        if (!authUser)
            return;
        setSnpLoader(true);
        let catgUrl =
            BACKEND_BASE_URL + GET_CUST;
        let data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
            },
        };
        //   console.log("getCustomerData => ",data);
        axios
            .post(catgUrl, data)
            .then((response) => {
                setSnpLoader(false);
                if (response.data.status === SUCCESS)
                    setCustData(response.data.payLoad.data);
                else
                    setSnpComponent({
                        ...snpComponent,
                        negativeReq: true,
                        negativeAction: "Home",
                        positiveReq: false,
                        showDialog: true,
                        outSideClickDismiss: false,
                        cancelExtra: true,
                        subTitle: "No Customer data is avaiable",
                        handleSnpCancel: () => navigate("/home"),
                    });
            })
            .catch((error) => {
                setSnpLoader(false);
                setSnpComponent({
                    ...snpComponent,
                    negativeReq: true,
                    negativeAction: "Home",
                    positiveReq: false,
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    subTitle: "No Customer data is avaiable",
                    handleSnpCancel: () => navigate("/home"),
                });
                console.log("Error : ", error);
                //window.location.href = "#/error";
            });
    };


    const handleUpdateCustomer = () => {
        setSnpLoader(true);
        let bUrl = BACKEND_BASE_URL + SET_CUSTOMER;
        let filledData = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                mobNo: singleCustData.mobNo,
                id: singleCustData.id,
                custName: singleCustData.custName,
                aadharId: singleCustData.aadharId,
                drivingLicense: singleCustData.drivingLicense,
                panNo: singleCustData.panNo,
                voterId: singleCustData.voterId,
                passport: singleCustData.passport,
                custDob: singleCustData.custDob,
                emailId: singleCustData.emailId,
                address: singleCustData.address,
                custProfession: singleCustData.custProfession,
                custFatherName: singleCustData.custFatherName,
                custCompanyName: singleCustData.custCompanyName,
                custGstDetails: singleCustData.custGstDetails,
                sex: singleCustData.sex,
            },
        };
        //console.log("handleCreateRoom", filledData)
        setShowDialog(false);
        setSingleCustData(INITIAL_SNP_COMPONENT);
        axios({
            method: "POST",                 //POST_ACTION
            url: bUrl,
            data: filledData,
            timeout: AXIOS_TIMEOUT
        }).then(response => {
            //console.log("responses => ", response.data);
            setSnpLoader(false);
            if (response.data.status === SUCCESS) {
                getCustomerData();
            }
        }).catch(error => {
            setSnpLoader(false);
            console.log("error : ", error);
            // window.location.href = "#/error";
        });
    }


    const columns = [
        { field: 'custName', headerName: 'Name', width: 220 },
        { field: 'sex', headerName: 'Gender', width: 100 },
        { field: 'mobNo', headerName: 'Mob No', width: 150 },
        { field: 'tDues', headerName: 'Dues', width: 120 },
        {
            field: "edit",
            headerName: "Edit",
            width: 20,
            renderCell: (cellValues) => {
                return (
                    <EditIcon
                        onClick={() => {
                            //console.log("event.row", cellValues.row)
                            if (isRoleAllowed(CUSTVIEW)) {
                                setShowDialog(true);
                                setSingleCustData({
                                    ...singleCustData, ...cellValues.row,
                                });
                            }
                        }}
                    ></EditIcon>
                );
            },
        },
    ];

    const handleViewBills = (data) => {
        //console.log("handleBookRoom",data ,encodedId);
        if (data.banquetBooking ?? false) {
            navigate("/createBanquetBill", { state: { id: data.id, via_bill: 1 } });
        } else {
            navigate("/createBill", { state: { id: data.id, via_bill: 1 } });
        }
    };
    const renderDialogDues = () => {
        return (
            <>
                <Grid container spacing={0}
                    alignItems="center" sx={{
                        padding: 0, ml: 3, mr: 3, mt: 3, mb: 3
                    }} >
                    <Grid md={12}>
                        <Typography variant="p" color="#02056e" fontWeight='bold'>Remaining Amt To Paid ₹{singleCustData.tDues}</Typography>
                    </Grid>
                </Grid>
                {singleCustData.pAudit.length > 0 &&
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table" className="rate_card">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">BookingId#</TableCell>
                                    <TableCell align="center">Accept By</TableCell>
                                    <TableCell align="center">Dues</TableCell>
                                    <TableCell align="center">View</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.values(singleCustData.pAudit).map((val) => {
                                    return (
                                        <TableRow
                                            className="rate_card--row"
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align="center">{val.bookingId}</TableCell>
                                            <TableCell align="center">{val.paidAcceptBy}</TableCell>
                                            <TableCell align="center">{val.pDues}</TableCell>
                                            <TableCell align="center"><VisibilityIcon
                                                onClick={() => handleViewBills(val)} /></TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </>
        );
    };


    const renderCustDialogContent = () => {
        return (
            <>
                <div>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                required
                                id="mobNo"
                                label="Enter Mob No"
                                name="mobNo"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.mobNo}
                                onChange={(e) => {
                                    setSingleCustData({
                                        ...singleCustData, mobNo: e.target.value,
                                    });
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                required
                                id="custName"
                                label="Enter Customer Name"
                                name="custName"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.custName}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, custName: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item md={6} sm={12} xs={12}>
                            <FormLabel component="legend">Select Gender</FormLabel>
                            <RadioGroup row aria-label="sex" name="sex" value={singleCustData.sex} onChange={(e) => setSingleCustData({
                                ...singleCustData, sex: e.target.value,
                            })} >
                                <FormControlLabel value={CustSex.Male} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={CustSex.Male} />
                                <FormControlLabel value={CustSex.Female} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={CustSex.Female} />
                                <FormControlLabel value={CustSex.Other} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={CustSex.Other} />
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="emailId"
                                label="Enter Email"
                                name="emailId"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.emailId}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, emailId: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="aadharId"
                                label="Enter Aadhar"
                                name="aadharId"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.aadharId}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, aadharId: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="drivingLicense"
                                label="Enter Driving License"
                                name="drivingLicense"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.drivingLicense}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, drivingLicense: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="panNo"
                                label="Enter Pan No"
                                name="panNo"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.panNo}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, panNo: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="voterId"
                                label="Enter Voter Id"
                                name="voterId"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.voterId}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, voterId: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="passport"
                                label="Enter Passport"
                                name="passport"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.passport}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, passport: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="custCompanyName"
                                label="Enter Company Name"
                                name="custCompanyName"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.custCompanyName}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, custCompanyName: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="custGstDetails"
                                label="Enter GST Details"
                                name="custGstDetails"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.custGstDetails}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, custGstDetails: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                type="date"
                                id="custDob"
                                label="Enter Dob"
                                name="custDob"
                                variant="filled"
                                size="small"
                                defaultValue={formatDateInReact(singleCustData.custDob)}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, custDob: formatDateInSnp(e.target.value),
                                })}
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    inputProps: {
                                        min: '1913-01-01',
                                        max: formatDateInReact(todayFormattedDate),
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="custProfession"
                                label="Enter Customer Profession"
                                name="custProfession"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.custProfession}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, custProfession: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                id="custFatherName"
                                label="Enter Fathers Name"
                                name="custFatherName"
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.custFatherName}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, custFatherName: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <TextField
                                required
                                id="address"
                                label="Enter Address"
                                name="address"
                                multiline={true}
                                rows={3}
                                variant="filled"
                                size="small"
                                defaultValue={singleCustData.address}
                                onChange={(e) => setSingleCustData({
                                    ...singleCustData, address: e.target.value,
                                })}
                                fullWidth
                            />
                        </Grid>
                        {
                            !isEmpty(singleCustData.mobNo) && <Grid item xs={12}>
                                <DocumentManager
                                    token={authUser.apiToken}
                                    shopHash={activeShopHash.id}
                                    CustMob={singleCustData.mobNo} />
                            </Grid>
                        }

                    </Grid>
                    {
                        (singleCustData.tDues > 0) &&
                        <Grid md={12}>
                            <center>
                                <Button variant="contained" color="bRed" onClick={(e) => setClearDues(true)} style={{ margin: "2px", float: "center" }}>
                                    Check Dues
                                </Button></center>
                        </Grid>
                    }
                </div>
            </>
        );
    };


    const renderMainDialogContent = () => {
        return (
            <>
                <div>
                    {
                        clearDues ? renderDialogDues() : renderCustDialogContent()
                    }
                </div></>
        );
    }

    const renderDialogAction = () => {
        return (
            <>
                {!clearDues && <Button variant="contained" color="primary" onClick={handleUpdateCustomer}>
                    Update
                </Button>}
                <Button variant="contained" color="primary" onClick={() => {
                    setShowDialog(false);
                    setClearDues(false);
                    setSingleCustData(INITIAL_SNP_COMPONENT);
                }}>
                    Dismiss
                </Button>
            </>
        );
    };

    const renderSnpContent = () => {
        return (
            <>
                <Grid container spacing={3}>
                    <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                        <CustomDataGrid
                            getRowId={row => row.id}
                            rows={custData}
                            loading={snpLoader}
                            columns={columns}
                            title="Show All Customer"
                        />
                    </Grid>
                </Grid>
                <DialogBox showDialog={showDialog}
                    title={"Edit Customer"}
                    onClose={() => {
                        setShowDialog(false);
                        setSingleCustData(INITIAL_SNP_COMPONENT);
                    }}
                    dialogContent={renderMainDialogContent()}
                    dialogActions={renderDialogAction()} />
            </>
        );
    };

    return (
        <>
            <SnpComponent showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                iconReq={snpComponent.iconReq}
                iconContent={snpComponent.iconContent}
                content={renderSnpContent()}
                onSnackClose={() => setSnpComponent({
                    ...snpComponent,
                    snackBarOpen: false,
                    snackBarMsg: "",
                })}
                handleSubmit={snpComponent.handleSnpSubmit}
                onCancel={snpComponent.handleSnpCancel}
                cancelExtra={snpComponent.cancelExtra}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </>
    );
};